<template>
  <b-modal
    no-close-on-backdrop
    id="password"
    title="INFORME A SENHA"
    hide-footer
    hide-header-close
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
    modal-class="password-modal"
  >
    <div class="password-container">
      <div class="password-header">
        <div class="header-icon">
          <i class="fas fa-lock"></i>
        </div>
        <h3 class="header-title">Confirme sua identidade</h3>
        <p class="header-subtitle">Digite sua senha para continuar</p>
      </div>

      <form @submit.prevent="evOnSubmit" class="password-form">
        <div class="form-section">
          <div class="input-group">
            <LabelRequiredField label="Senha" class="modern-label" />
            <div class="input-wrapper">
              <BInputPassword
                v-model="password"
                class="modern-input"
                placeholder="Digite sua senha"
              />
              <div class="input-icon">
                <i class="fas fa-key"></i>
              </div>
            </div>
          </div>

          <ErrorsMessages :errors="errorsPassword" v-if="errors.length == 0" />
          <ErrorsMessages :errors="errors" />
        </div>

        <div class="actions-section">
          <v-btn @click="$bvModal.hide('password')" class="btn-cancel-modern">
            <i class="fas fa-times mr-2"></i>
            Cancelar
          </v-btn>
          <v-btn :disabled="loading" type="submit" class="btn-confirm-modern">
            <i class="fas fa-check mr-2"></i>
            {{ loading ? "Verificando..." : "Confirmar" }}
          </v-btn>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField";
import ErrorsMessages from "../Components/ErrorsMessages";
import BInputPassword from "../Components/BInputPassword.vue";

export default {
  name: "ChangePassword",
  components: {
    LabelRequiredField,
    ErrorsMessages,
    BInputPassword,
  },
  props: {
    errorsPassword: Array,
    loading: Boolean,
  },
  data() {
    return {
      password: "",
      errors: [],
    };
  },
  methods: {
    async evOnShow() {
      this.password = "";
    },
    async evOnShown() {},
    async evOnHide() {},
    async evOnSubmit() {
      if (!this.password || !String(this.password).trim()) {
        this.errors = [{ id: this.errors.length, message: "Informe a senha" }];
        return;
      }

      this.errors = [];
      this.$emit("password", this.password);
    },
  },
};
</script>

<style scoped>
/* Modal customizations */
.password-modal >>> .modal-dialog {
  max-width: 480px;
}

.password-modal >>> .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

.password-modal >>> .modal-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  border: none;
  padding: 0;
  display: none;
}

.password-modal >>> .modal-body {
  padding: 0;
}

/* Container */
.password-container {
  padding: 0;
}

/* Header */
.password-header {
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  text-align: center;
  padding: 32px 24px;
}

.header-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 24px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.header-subtitle {
  font-size: 14px;
  margin: 0;
  opacity: 0.9;
}

/* Form */
.password-form {
  padding: 32px 24px 24px;
}

.form-section {
  margin-bottom: 24px;
}

.input-group {
  position: relative;
}

.modern-label {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
  font-size: 14px;
}

.input-wrapper {
  position: relative;
}

.modern-input {
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  padding: 12px 16px 12px 48px;
  font-size: 16px;
  transition: all 0.3s ease;
  background: #f9fafb;
}

.modern-input:focus {
  border-color: #0f65b0;
  background: white;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
}

.input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 16px;
}

/* Actions */
.actions-section {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
}

.btn-cancel-modern {
  flex: 1;
  background: transparent !important;
  color: #6b7280 !important;
  border: 2px solid #d1d5db !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

.btn-cancel-modern:hover {
  background: #f3f4f6 !important;
  border-color: #9ca3af !important;
  color: #374151 !important;
  transform: translateY(-1px) !important;
}

.btn-confirm-modern {
  flex: 1;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-confirm-modern:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(15, 101, 176, 0.4) !important;
}

.btn-confirm-modern:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
}

/* Responsive */
@media (max-width: 576px) {
  .password-modal >>> .modal-dialog {
    margin: 16px;
    max-width: none;
  }

  .password-header {
    padding: 24px 20px;
  }

  .header-icon {
    width: 56px;
    height: 56px;
    font-size: 20px;
  }

  .header-title {
    font-size: 20px;
  }

  .password-form {
    padding: 24px 20px 20px;
  }

  .actions-section {
    flex-direction: column;
  }
}
</style>